<template>
  <div class="home-view">
    <!-- <h5>{{ screenHeight + 'x' + screenWidth }}</h5> -->
    <LandingPageDesktopVue v-if="!isMobileView" :userProfile="USER_PROFILE" :profileLoaded="isProfileLoaded" />
    <LandingPageMobileVue v-else :userProfile="USER_PROFILE" :profileLoaded="isProfileLoaded" />
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted, onBeforeMount } from 'vue';
import LandingPageDesktopVue from '@/components/general/ChildComponents/LandingPageDesktop.vue';
import LandingPageMobileVue from '@/components/general/ChildComponents/LandingPageMobile.vue';
import { useRouter } from 'vue-router';
import { getUserProfiles, getUserProfileById, getFile, getDataFromBlob } from '@/controllers/BaseController';
import { useOAuthService } from '@/services/OAuthService'
import user_avatar from '@/assets/General/user_avatar.png'



export default defineComponent({
  name: 'HomeView',
  components: {
    LandingPageDesktopVue,
    LandingPageMobileVue,
  },
  setup() {
    const isMobileView = ref(window.innerWidth <= 769);
    const isProfileLoaded = ref(false);
    const router = useRouter();
    const USER_PROFILE = ref(null);
    const screenHeight = ref(window.innerHeight);
    const screenWidth = ref(window.innerWidth);

    const handleResize = () => {
      isMobileView.value = window.innerWidth <= 769
      screenHeight.value = window.innerHeight;
      screenWidth.value = window.innerWidth;
    };
    onBeforeMount(async () => {
      const { getCustomer } = await import('@/assets/Branding/branding.js');
      const customer = await getCustomer();
      if (customer !== 'pia') {
        router.replace({ path: '/infocenter' }); // Redirect and replace history
      }
    });
    onMounted(async () => {
      window.scrollTo(0, 0);
      try {
        handleResize();
        isProfileLoaded.value = false;
        let fallbackProfileImage = user_avatar;
        window.addEventListener('resize', handleResize);
        let profiles = await getUserProfiles();
        let tokenProfile = await useOAuthService().getUserProfile();
        USER_PROFILE.value = tokenProfile;
        let userProfile = profiles.find(profile => profile.email === tokenProfile.email);
        if (userProfile && userProfile.files && userProfile.files.entities) {
          let profileImageIdsArray = userProfile.files.entities.filter(file => file.type === 'profileImage');
          if (profileImageIdsArray.length > 0) {
            let profileImageId = profileImageIdsArray[0].id;
            let image = profileImageId ? await getFile(profileImageId) : null;
            let profileImage = image ? await getDataFromBlob(image) : fallbackProfileImage;
            USER_PROFILE.value.profileImage = profileImage;
          }
        }
        else {
          USER_PROFILE.value.profileImage = fallbackProfileImage;
        }
        //console.log('USER_PROFILE:', JSON.parse(JSON.stringify(USER_PROFILE.value)));


      } catch (error) {
        console.error('Error during component mount:', error);
        isProfileLoaded.value = true;
      } finally {
        isProfileLoaded.value = true;
      }
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize); // Clean up event listener
    });

    return {
      isMobileView,
      router,
      user_avatar,
      USER_PROFILE,
      screenHeight,
      screenWidth,
      handleResize,
      isProfileLoaded
    };
  },
});
</script>

<style scoped>
.home-view {
  /* display: flex; */
  flex-direction: column;
  /* min-height: 100vh;
  background: linear-gradient(135deg, #eef2f6 0%, #ffffff 100%); */
}
</style>